import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
  glow?: boolean
  onClick?: () => void
}

export function Card({ children, className = '', hover = false, glow = false, onClick }: CardProps) {
  const isInteractive = !!(hover || onClick)
  return (
    <div
      onClick={onClick}
      className={`
        bg-surface-raised border border-white/[0.07] rounded-xl
        ${isInteractive
          ? 'cursor-pointer transition-all duration-[200ms] hover:border-brand-accent/30 hover:bg-surface-overlay active:scale-[0.985] active:brightness-95'
          : ''}
        ${glow ? 'shadow-glow' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  )
}

export function CardHeader({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`px-5 py-4 border-b border-white/[0.07] ${className}`}>
      {children}
    </div>
  )
}

export function CardBody({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return <div className={`p-5 ${className}`}>{children}</div>
}
